var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "password-strength" }, [
    _c("div", { staticClass: "strength-meter" }, [
      _c("div", { staticClass: "strength-bar" }, [
        _c("div", {
          staticClass: "strength-bar-fill",
          class: "strength-" + _vm.strengthLevel,
          style: { width: _vm.strengthPercentage + "%" },
        }),
      ]),
      _vm._v(" "),
      _vm.password
        ? _c("div", { staticClass: "strength-text" }, [
            _c("span", { staticClass: "strength-label" }, [
              _vm._v("Password Strength:"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { class: "strength-value strength-" + _vm.strengthLevel },
              [_vm._v(_vm._s(_vm.strengthText))]
            ),
          ])
        : _c("div", { staticClass: "strength-text-placeholder" }, [
            _c("span", { staticClass: "strength-label" }, [
              _vm._v("Password Strength:"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "strength-value" }, [
              _vm._v("Enter a password to see strength"),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }